import { EmConstrucao } from '../app/EmConstrucao.js';

export function TerritorioDetalheTela() {
  return <EmConstrucao titulo="Território" />;
}
